import { render, staticRenderFns } from "./CrewNews.vue?vue&type=template&id=eec070de&scoped=true"
import script from "./CrewNews.vue?vue&type=script&lang=js"
export * from "./CrewNews.vue?vue&type=script&lang=js"
import style0 from "./CrewNews.vue?vue&type=style&index=0&id=eec070de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec070de",
  null
  
)

export default component.exports